import { useLocalStorage } from 'react-use';

function getCategoryFromParams(categoriesMap) {
  const windowParams = new URL(document.location).searchParams;
  const category = {};
  if (windowParams.get('categoryName') && windowParams.get('categoryValue')) {
    category.label = windowParams.get('categoryName');
    category.value = JSON.parse(
      decodeURIComponent(windowParams.get('categoryValue')),
    );
    return category;
  }
  if (windowParams.get('repCategories')) {
    const cats = windowParams.get('repCategories').split(',');
    return cats.map((cat) => categoriesMap.find((c) => c.id === cat));
  }
  return undefined;
}

export default function useCompanyCategory(localStorageKey, categoriesMap) {
  const [savedCategory, setSavedCategory] = useLocalStorage(localStorageKey);
  const category = getCategoryFromParams(categoriesMap) || savedCategory;
  return { savedCategory: category, setSavedCategory };
}
